import React from 'react'
import { SimpleTooltip } from '../simple-tooltip'
import { mergeClasses } from '../../../helpers/styling'

export function MiniButton(props: {
  title?: string
  className?: string
  children: React.ReactNode
} & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const { title, className, children, ...buttonProps } = props
  return (
    <SimpleTooltip tooltip={title} delayDuration={700}>
      <button
        type={props.type ?? "button"}
        className={mergeClasses(
          `inline-flex p-1 items-center justify-center
          hover:text-black hover:bg-gray-200`,
          className)}
        {...buttonProps}
      >
        {children}
      </button>
    </SimpleTooltip>
  )
}
